import { tierThemes } from 'features/premium/benefits';
import { isPremiumTier } from 'features/premium/entities';
import useColors from 'hooks/useColors';
import React, { useCallback } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import FastImage from 'utils/packages/rnFastImage';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { CardView } from './CardView';
import Text from './Text';
import { rem } from './values';
const TEAM_MEMBERS = [
    { name: 'Connor', avatar: require('./img/connor.png') },
    { name: 'Yvonne', avatar: require('./img/yvonne.png') },
];
const FeatureSupportCard = ({ tier }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const onPressSupport = useCallback(() => {
        navigation.navigateDeprecated('Support', {});
    }, []);
    return (<CardView noMarginTop title="Talk to our team">
      {TEAM_MEMBERS.map((teamMember) => (<TouchableHighlight onPress={onPressSupport} key={teamMember.name} underlayColor={colors.background.underlay}>
          <View style={styles.teamMemberRow}>
            <FastImage style={styles.teamMemberImage} source={teamMember.avatar}/>
            <View style={styles.teamMemberTextContainer}>
              <Text Text-16 OffBlack>
                Speak to {teamMember.name}
              </Text>
              <Text TextThin-14 Secondary>
                {teamMember.name} can help you set up your{' '}
                {isPremiumTier(tier)
                ? `${tierThemes[tier].name} plan`
                : 'Emma account'}
                . Mon-Fri 9am-6pm
              </Text>
            </View>
          </View>
        </TouchableHighlight>))}
    </CardView>);
};
const styles = StyleSheet.create({
    teamMemberRow: {
        flexDirection: 'row',
        padding: rem(16),
        alignItems: 'center',
    },
    teamMemberImage: {
        width: rem(44),
        height: rem(44),
        borderRadius: rem(44),
        marginRight: rem(16),
    },
    teamMemberTextContainer: {
        flexDirection: 'column',
        flex: 1,
    },
});
export default FeatureSupportCard;
